import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react'

export type SortDir = 'asc' | 'desc'

interface SortIconProps {
  field: string
  sortField: string
  sortDir: SortDir
}

const SortIcon = ({ field, sortField, sortDir }: SortIconProps) => {
  if (field !== sortField)
    return <ArrowUpDown className='text-text-tertiary ml-1 inline h-3 w-3' />
  return sortDir === 'asc' ? (
    <ChevronUp className='ml-1 inline h-3 w-3 text-violet-400' />
  ) : (
    <ChevronDown className='ml-1 inline h-3 w-3 text-violet-400' />
  )
}

export default SortIcon
